var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { MessageUIRequest, MessageUIRequestType } from "@/share/Message";
import { action, makeObservable, observable } from "mobx";
export class UnreadInfoStore {
    constructor() {
        this.newinvites = 0;
        this.unreadletrs = new Set();
        this.tagsUnread = new Map();
        this.hasnewpublicconatct = false;
        this.unreadPublicContactInvite = new Set();
        this.unreadPublicContactLetrs = new Set();
        this.newinvitescount = 0;
        this.activecalls = 0;
        this.activeletr = "";
        this.hasmissedcalls = false;
        makeObservable(this);
        APPEvent.addSubscriberForActiveLetr((lt) => this.activeletr = lt);
        APPEvent.addSubscriberForActiveLetrObject((l) => this.activeletrobj = l);
        APPEvent.addSubscriberForUnreadInfo((info) => {
            this.setNewInvites(info.newinvites);
            this.clearTagsUnread();
            this.setNewinvitescount(info.newinvitescount);
            info.tagsNumber.forEach((val) => {
                if (this.activeletr && this.activeletrobj !== undefined) {
                    const tags = this.activeletrobj.tags;
                    if (tags.has(val.tagid) && val.unread > 0) {
                        val.unread -= 1;
                    }
                }
                this.addTagsUnread(val.tagid, val.unread);
            });
            this.removeAllUnreadLetrs();
            info.unreadletrs.forEach((lt) => {
                this.addUnreadLetrs(lt.valueOf());
            });
            this.clearUnreadPublicContacts();
            if (info.addedAsmanager) {
                this.setHasNewPubliContact();
            }
            this.clearUnreadPublicContactInvites();
            if (info.unreadPublicContactInvites) {
                info.unreadPublicContactInvites.forEach((inv) => this.setNewPublicContactInvite(inv));
            }
            this.clearUnreadPublicContactLetrs();
            if (info.unreadPublicContactLetrs) {
                info.unreadPublicContactLetrs.forEach((lts) => this.setNewPublicContactLetr(lts));
            }
            this.setActiveCalls(info.activecalls);
            this.setHasMissedCalls(info.missedcalls);
        });
    }
    get hasActivityInManagedContact() {
        return this.hasnewpublicconatct || this.unreadPublicContactInvite.size > 0 || this.unreadPublicContactLetrs.size > 0;
    }
    setNewinvitescount(count) {
        this.newinvitescount = count;
    }
    setActiveCalls(count) {
        this.activecalls = count;
    }
    clearUnreadPublicContacts() {
        this.hasnewpublicconatct = false;
    }
    clearUnreadPublicContactInvites() {
        this.unreadPublicContactInvite.clear();
    }
    clearUnreadPublicContactLetrs() {
        this.unreadPublicContactLetrs.clear();
    }
    setNewPublicContactLetr(contactid) {
        this.unreadPublicContactLetrs.add(contactid);
    }
    setNewPublicContactInvite(contactid) {
        this.unreadPublicContactLetrs.add(contactid);
    }
    setHasNewPubliContact() {
        this.hasnewpublicconatct = true;
    }
    setHasMissedCalls(hasmissedcall) {
        this.hasmissedcalls = hasmissedcall;
    }
    setNewInvites(inv) {
        this.newinvites = inv;
    }
    clearTagsUnread() {
        this.tagsUnread.clear();
    }
    addTagsUnread(tagid, unreadocunt) {
        this.tagsUnread.set(tagid, unreadocunt);
    }
    addUnreadLetrs(letrid) {
        if (letrid === this.activeletr) {
            // just to mark we have seen this..
            const req = new MessageUIRequest();
            req.letrid = this.activeletr;
            req.count = 1;
            req.sortAsc = false;
            req.type = MessageUIRequestType.Fetch;
            req.time = new Date().getTime() + 60 * 60 * 24 * 1000;
            Apphandler.sendMessage("messages", req);
        }
        else {
            this.unreadletrs.add(letrid);
        }
    }
    removeAllUnreadLetrs() {
        this.unreadletrs.clear();
    }
    getTagUnread(tagid) {
        var _a;
        return (_a = this.tagsUnread.get(tagid)) !== null && _a !== void 0 ? _a : 0;
    }
    hasUnreadLetr(letrid) {
        return this.unreadletrs.has(letrid);
    }
    publicContactHasInvites(id) {
        return this.unreadPublicContactInvite.has(id);
    }
    publicContactHasLetrs(id) {
        return this.unreadPublicContactLetrs.has(id);
    }
    isPublicContactUnread(id) {
        return this.publicContactHasInvites(id) || this.publicContactHasLetrs(id);
    }
    reset() {
        this.clearTagsUnread();
        this.setNewInvites(0);
        this.removeAllUnreadLetrs();
        this.clearUnreadPublicContactInvites();
        this.clearUnreadPublicContactLetrs();
        this.clearUnreadPublicContacts();
        this.setActiveCalls(0);
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], UnreadInfoStore.prototype, "newinvites", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], UnreadInfoStore.prototype, "unreadletrs", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], UnreadInfoStore.prototype, "tagsUnread", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UnreadInfoStore.prototype, "hasnewpublicconatct", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], UnreadInfoStore.prototype, "unreadPublicContactInvite", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], UnreadInfoStore.prototype, "unreadPublicContactLetrs", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], UnreadInfoStore.prototype, "newinvitescount", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], UnreadInfoStore.prototype, "activecalls", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UnreadInfoStore.prototype, "hasmissedcalls", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], UnreadInfoStore.prototype, "setNewinvitescount", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], UnreadInfoStore.prototype, "setActiveCalls", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UnreadInfoStore.prototype, "clearUnreadPublicContacts", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UnreadInfoStore.prototype, "clearUnreadPublicContactInvites", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UnreadInfoStore.prototype, "clearUnreadPublicContactLetrs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UnreadInfoStore.prototype, "setNewPublicContactLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UnreadInfoStore.prototype, "setNewPublicContactInvite", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UnreadInfoStore.prototype, "setHasNewPubliContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UnreadInfoStore.prototype, "setHasMissedCalls", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], UnreadInfoStore.prototype, "setNewInvites", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UnreadInfoStore.prototype, "clearTagsUnread", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Number]),
    __metadata("design:returntype", void 0)
], UnreadInfoStore.prototype, "addTagsUnread", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UnreadInfoStore.prototype, "addUnreadLetrs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UnreadInfoStore.prototype, "removeAllUnreadLetrs", null);
